import { DeliveryState, Workflow } from "../enums/orders";
import { DeliveryBatchState, PickupTaskState } from "../enums/tasks";
import { UserType } from "../enums/users";
import { User } from "../interfaces/common/authentication";
import { IDeliveryBatch, IPickupTask } from "../interfaces/delivery-company/tasks";

export const isFrozen = (task: IDeliveryBatch): boolean => {
    return task.status !== DeliveryBatchState.ASSIGNED
}

export const DeliveryBatchQRCodePrefix = "3"

export const deliveryBatchToQRcodeID = (task: IDeliveryBatch): string => {
    return `${DeliveryBatchQRCodePrefix}${task.id}`
}

export const get_district_set = (task: IDeliveryBatch) => {
    return new Set(task.orders.map(item => {
        if (item.workflow === Workflow.STANDARD) return item.customer_location?.area!.district;

        if (item.workflow === Workflow.RETURN) return item.merchant_location?.area!.district;

        return "";
    }))
}